// extracted by mini-css-extract-plugin
module.exports = {"footer":"_7a3fb80146--footer--LNUWR","description":"_7a3fb80146--description--R2hE_","button":"_7a3fb80146--button--U2AfV"};